const paramMap = {
    ul_cpuname: 'cpuName',
    ul_gpuname: 'gpuName',
    ul_gputype: 'gpuType',
    ul_gpunumber: 'gpuNumber',
    ul_cpuoc: 'cpuOC',
    ul_memchannels: 'memchannels',
    ul_memfrequency: 'memfrequency',
};
export const graphicsPresets = ['Low', 'Medium', 'High'];
const MINIMUM_FPS = 30;
const MINIMUM_FILTERED_GAME_COUNT = 15;
const pickParams = params => {
    return Object.keys(params).reduce((r, k) => {
        const mappedKey = paramMap[k];
        if (mappedKey) {
            r[mappedKey] = params[k];
        }
        return r;
    }, {});
};

export const getULParams = (skuList, ULList) => {
    const params = Object.keys(ULList || {}).reduce((r, sku) => {
        if (skuList.includes(sku)) {
            //TODO: temp add default parameter for testing
            r = { gpuNumber: 1, ...r, ...pickParams(ULList[sku]) };
        }
        return r;
    }, {});
    //if not all required params provided throw and execption
    if (Object.keys(params).length !== Object.keys(paramMap).length) {
        throw new Error(`Missing required parameters. Received ${JSON.stringify(params)}`);
    }
    return params;
};

export const pickFPS = (game, gameTitles, graphicPreset) => {
    const fpsValue = ((gameTitles || {})[game.name] || {})[graphicPreset];
    //an FPS value of 0 is intentionally not rendered on the front end
    return fpsValue ? `${fpsValue} FPS` : null;
};

export const formatFPS = (fpsObj, graphicsPreset) => {
    //an FPS value of 0 is intentionally not rendered on the front end
    if (!fpsObj || !fpsObj.avgFps) return null;
    return graphicsPreset ? `${graphicsPreset} \u00A0|\u00A0 ${fpsObj.avgFps} FPS` : `${fpsObj.avgFps} FPS`;
};

export const filterGamesByFpsThreshold = (games, fpsData = {}) => {
    const eligibleGames = games.filter(game => Number(fpsData[game.id]?.avgFps) >= MINIMUM_FPS);

    return eligibleGames.length >= MINIMUM_FILTERED_GAME_COUNT ? eligibleGames : games;
};
